import { CloseSquareOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { BREACK_POINT_HEADER } from "../../common/constant";
import { addProductToCart } from "../../redux/reducers/slice/cart";
import { removeCompareProduct } from "../../redux/reducers/slice/common";
import { checkSpecialMattress } from "../../shared/helpers";
import NotificationAddToCartSuccess from "../notification";
import ProductItemGiftModal from "../productItem/giftModal";
import "./style.scss";

export interface ICompareProductItemProps {
  product: ICompareProduct | null;
  index: number;
}

export interface ICompareProduct {
  img: string;
  name: string;
  price_promotion: string;
  price: string;
  properties: any;
  gifts: any;
  dataAddToCart: any;
}

export interface ICompareProductProperty {
  value: string;
  label: string;
}

const CompareProductItem = (props: ICompareProductItemProps) => {
  const { product, index } = props;
  const dispatch = useDispatch();
  const [visibleGiftModal, setVisibleGiftModal] = useState(false);

  const openGiftModal = () => {
    setVisibleGiftModal(true);
  };
  const closeGiftModal = () => {
    setVisibleGiftModal(false);
  };
  const removeProduct = () => {
    dispatch(removeCompareProduct(index));
  };

  const addToCartWithEffect = async () => {
    const addToCartResponse = await dispatch(
      addProductToCart(product?.dataAddToCart, true, 1)
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: product?.name,
        productFeature: product?.properties?.feature?.label,
      });

      const compareLstNode = document.querySelector(".compare-content");

      if (!compareLstNode) {
        console.log("compareLstNode is null");
        return;
      }

      const compareProductNodes = compareLstNode.querySelectorAll(
        ".compare-product-item"
      );

      if (!compareProductNodes) {
        console.log("compareProductNode is null");
        return;
      }

      const classNameViewCart =
        window.innerWidth > BREACK_POINT_HEADER
          ? ".kd-shopping-cart"
          : ".kd-shopping-cart-mobile";

      const cartNode: any = document.querySelector(classNameViewCart);

      if (!cartNode) {
        console.log("cartNode is null");
        return;
      }

      cartNode.style = "";

      const compareProductImgNode = compareProductNodes[index].querySelector(
        ".compare-product-item__avatar"
      );

      if (!compareProductImgNode) {
        console.log("compareProductImgNode is null");
        return;
      }

      const boundingProductItem =
        compareProductNodes[index].getBoundingClientRect();
      const boundingCart = cartNode.getBoundingClientRect();

      const _image: any = compareProductImgNode.cloneNode(true);

      _image.style = `
      z-index: 1111;
      width: 100px;
      opacity:0.9;
      position:fixed;
      top: ${boundingProductItem.top}px; 
      left: ${boundingProductItem.left}px;
      transition: left 1s, top 1s, width 1s, opacity 1s cubic-bezier(1, 1, 1, 1)`;

      var rechange = document.body.appendChild(_image);

      setTimeout(function () {
        _image.style.left = boundingCart.left + "px";
        _image.style.top = boundingCart.top + "px";
        _image.style.width = "40px";
        _image.style.opacity = "0";
      }, 200);

      setTimeout(function () {
        cartNode.style = "animation: shake 0.2s";
        rechange.parentNode.removeChild(rechange);
      }, 1000);
    }
  };

  return (
    <>
      {product ? (
        <div key={index} className="compare-product-item">
          <div className="compare-product-item__avatar">
            <img src={product.img} alt="" />
          </div>
          <p className="compare-product-item__name">{product.name}</p>
          <div className="compare-product-item-properties">
            <p className="compare-product-item__property">
              {product.properties?.pattern?.label}
            </p>
            <p className="compare-product-item__property">
              {product.properties?.desk?.label}
            </p>

            <p className="compare-product-item__property">
              {product.properties.cover?.label}
            </p>

            <p className="compare-product-item__property">
              {product.properties.foam?.label}
            </p>

            <p className="compare-product-item__property">
              {product.properties?.feature?.label}
            </p>
          </div>
          <p className="compare-product-item__price-promotion">
            {product.price_promotion} VND
          </p>
          {!checkSpecialMattress(product.price, product.price_promotion) && (
            <p className="compare-product-item__price">
              &nbsp;({product.price} VND)&nbsp;
            </p>
          )}

          <a className="compare-product-item__gifts" onClick={openGiftModal}>
            {!!(Array.isArray(product.gifts) && product.gifts.length) &&
              `Quà tặng (${product.gifts.length})`}
          </a>

          <button
            className="compare-product-item__remove-btn"
            onClick={removeProduct}>
            <CloseSquareOutlined />
          </button>

          <div
            onClick={addToCartWithEffect}
            className="compare-product-item__add-to-cart">
            <span>Thêm vào giỏ hàng</span>
            {/* <RightOutlined /> */}
            {/* <img
              src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_cart-49.svg"
              alt=""
            /> */}
          </div>
        </div>
      ) : (
        <div
          key={index}
          className="compare-product-item compare-product-item--available">
          <div className="compare-product-item__icon-available">
            <PlusOutlined />
          </div>
          <span className="compare-product-item__name">Sản phẩm trống</span>
        </div>
      )}

      <ProductItemGiftModal
        quantity={1}
        visible={visibleGiftModal}
        closeGiftModal={closeGiftModal}
        gifts={product?.gifts}
      />
    </>
  );
};

export default React.memo(CompareProductItem);
